import { TranslateService } from '@ngx-translate/core';

import { EstimatedCronosDate } from '../../domain/models/estimated-cronos-date.model';

// TODO ECOMDUTI-18440 [TechDebt] - Depender de modelos de datos de dominio, no de modelos de terceros como el que nos proporciona el API
import { ShippingMethod } from '@api/shipping/models/shipping.model';
import { getCorrectCalendarFormatUseCase } from '@core/application/use-cases/dates/get-correct-calendar-format.use-case';
import { DatesService } from '@core/services/date/dates.use-cases';

function getDateFormatted(
    translateService: TranslateService,
    date: any,
    langCode: string,
    countryCode: string
): string {
    const fixedDate = new Date(DatesService.fixDateString(date));
    return getCorrectCalendarFormatUseCase(translateService, fixedDate, langCode, countryCode);
}

/**
 * Get the estimated delivery date for the given order tracking. The order may or may not have estimation data from the
 * Cronos service.
 *
 * @param translateService dependency. A translation service instance
 * @param orderTracking the order tracking data
 * @param langCode the language code
 * @param countryCode the country code
 * @returns
 */
export function getCronosDeliveryDateUseCase(
    translateService: TranslateService,
    orderTracking: any[] | ShippingMethod[],
    langCode: string,
    countryCode: string
): EstimatedCronosDate {
    let deliveryDate: string;
    let initSetValues: boolean = false;
    let cronosEnable: boolean = true;
    let maxDate: string;
    let minDate: string;

    if (!orderTracking || orderTracking.length === 0) {
        return undefined;
    }

    for (const obj of orderTracking) {
        if (!obj.deliveryInfo) {
            cronosEnable = false;
            break;
        }
        if (obj.fechaEstimada && obj.deliveryInfo?.deliveryDateChanged) {
            deliveryDate = getDateFormatted(translateService, obj.fechaEstimada, langCode, countryCode);
        } else if (obj.deliveryInfo?.deliveryDate) {
            deliveryDate = getDateFormatted(translateService, obj.deliveryInfo.deliveryDate, langCode, countryCode);
        } else {
            deliveryDate = getDateFormatted(translateService, obj.fechaEstimada, langCode, countryCode);
        }

        const max = DatesService.fixDateString(obj.deliveryInfo?.maximumGlobalDeliveryDate)?.toString();
        const min = DatesService.fixDateString(obj.deliveryInfo?.minimumGlobalDeliveryDate)?.toString();
        if (!max || !min) {
            cronosEnable = false;
            break;
        }
        // Sólo para la primera interacción
        if (!initSetValues) {
            maxDate = max;
            minDate = min;
            initSetValues = true;
        }
        if (new Date(max).getTime() > new Date(maxDate).getTime()) {
            maxDate = max;
        }
        if (new Date(min).getTime() < new Date(minDate).getTime()) {
            minDate = min;
        }
    }

    if (minDate) {
        minDate = getDateFormatted(translateService, minDate, langCode, countryCode);
    }
    if (maxDate) {
        maxDate = getDateFormatted(translateService, maxDate, langCode, countryCode);
    }

    if (cronosEnable) {
        return {
            deliveryDate,
            maxDate,
            minDate,
        };
    }

    return undefined;
}
